/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

// import EdgeInsetsPropType from "../EdgeInsetsPropType";
// import StyleSheetPropType from "../../modules/StyleSheetPropType";
// import ViewStylePropTypes from "./ViewStylePropTypes";
import { any, bool, func, object, oneOf, string } from "prop-types";

// const stylePropType = StyleSheetPropType(ViewStylePropTypes);

const ViewPropTypes = {
  accessibilityComponentType: string,
  accessibilityLabel: string,
  accessibilityLiveRegion: oneOf(["assertive", "none", "polite"]),
  accessibilityRelationship: object,
  accessibilityRole: string,
  accessibilityState: object,
  accessible: bool,
  children: any,
  forwardedRef: any,
  hitSlop: any, //EdgeInsetsPropType,
  importantForAccessibility: oneOf([
    "auto",
    "no",
    "no-hide-descendants",
    "yes"
  ]),
  nativeID: string,
  onBlur: func,
  onClick: func,
  onClickCapture: func,
  onFocus: func,
  onLayout: func,
  onMoveShouldSetResponder: func,
  onMoveShouldSetResponderCapture: func,
  onResponderGrant: func,
  onResponderMove: func,
  onResponderReject: func,
  onResponderRelease: func,
  onResponderTerminate: func,
  onResponderTerminationRequest: func,
  onStartShouldSetResponder: func,
  onStartShouldSetResponderCapture: func,
  onTouchCancel: func,
  onTouchCancelCapture: func,
  onTouchEnd: func,
  onTouchEndCapture: func,
  onTouchMove: func,
  onTouchMoveCapture: func,
  onTouchStart: func,
  onTouchStartCapture: func,
  pointerEvents: oneOf(["auto", "box-none", "box-only", "none"]),
  style: any, //stylePropType,
  testID: string,
  // web extensions
  onContextMenu: func,
  itemID: string,
  itemRef: string,
  itemProp: string,
  itemScope: string,
  itemType: string,
  // compatibility with React Native
  accessibilityViewIsModal: bool,
  collapsable: bool,
  needsOffscreenAlphaCompositing: bool,
  onAccessibilityTap: func,
  onMagicTap: func,
  removeClippedSubviews: bool,
  renderToHardwareTextureAndroid: bool,
  shouldRasterizeIOS: bool,
  tvParallaxProperties: object
};

export default ViewPropTypes;
